export enum AmountKey {
  Turnover = 'turnover',
  Vat = 'vat',
}
